import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import {
  CharterClauseDto,
  CharterGovernanceDto,
} from '@interfaces/corporate-charter/responses/corporate-charter.response';
import { CharterProvenanceComponent } from '@features/dashboard/company/corporate-charter/components/charter-provenance/charter-provenance.component';
import { buildSigningSummary } from '@features/dashboard/company/corporate-charter/corporate-charter-signing.util';

/**
 * "Quem acionar para assinar": para cada situação (contratos com bancos, garantias, venda ou oneração de bens, atos do
 * dia a dia e procurações), quem a empresa precisa chamar e em que combinação, com o limite de valor e a procedência
 * num ícone. Montado só a partir das regras lidas (`signingRules` com `scope`); situação sem regra própria diz que o
 * contrato não especifica e aponta a regra geral. Cláusula de crédito que exige quórum de sócios aparece como alerta.
 */
@Component({
  selector: 'app-charter-signing-guide',
  imports: [CharterProvenanceComponent],
  templateUrl: './charter-signing-guide.component.html',
  styleUrl: './charter-signing-guide.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CharterSigningGuideComponent {
  readonly governance = input.required<CharterGovernanceDto>();
  readonly clauses = input<CharterClauseDto[]>([]);
  readonly isCorporation = input(false);
  readonly currency = input('BRL');

  protected readonly summary = computed(() =>
    buildSigningSummary(this.governance(), this.clauses(), this.isCorporation(), this.currency())
  );
}
